import React, { useEffect } from 'react'
import './ASRTestView.scss'
import { logSessionInfo } from '../../../../../services/logger'

export default function ASRTestView(props) {
  const { 
    speechProps, 
    onStartPatter,
    history,
  } = props

  useEffect(() => {
    // Speak the onMount pattern first
    speechProps.abortSpeech()
    speechProps.speakWithPromise({ textToSpeak: onStartPatter })
      .then(() => {
        // Redirect to the actual ASR route with teacher test parameter
        // This will unmount this component and mount the ReaderManager with the ASR story
        history.push("/student/pre-checks/asr?teacherTest=true")
      })
      .catch(error => {
        console.error('Error speaking patter, still redirecting:', error)
        history.push("/student/pre-checks/asr?teacherTest=true")
      })

    return () => {
      // Cleanup
      speechProps.stopListening()
    }
  }, [])


  return (
    <div className="asr-test-view">
      <div className="asr-test-view__content">
        {/* No UI as requested */}
      </div>
    </div>
  )
} 